import DataTable from 'react-data-table-component';

const customStyles = {
    rows: {
        style: {
            minHeight: '72px', // override the row height
        },
    },
    headCells: {
        style: {
            fontSize: '5rem', // override the cell padding for head cells
            backgroundColor: 'var(--bg-base-color)',
            color: 'var(--base-white)',

        },
    },
    cells: {
        style: {
            paddingLeft: '8px', // override the cell padding for data cells
            paddingRight: '8px',
        },
    },
    contextMenu: {
        style: {
            fontSize: '25px',
            paddingLeft: '16px',
            paddingRight: '8px',
            borderRadius: '1.2rem',
            transform: 'translate3d(0, -100%, 0)',
            fontFamily: "'Montserrat', sans-serif",
            fontWeight: 700,
            transitionDuration: '125ms',
            transitionTimingFunction: 'cubic-bezier(0, 0, 0.2, 1)',
            willChange: 'transform',
            backgroundColor: 'var(--bg-background-color)'
        },
        activeStyle: {
            transform: 'translate3d(0, 0, 0)',
        },
    },
};

const paginationComponentOptions = {
    selectAllRowsItem: true,
    selectAllRowsItemText: 'Todos',
    noRowsPerPage: false,
    paginationPerPage: 5,
};
const conditionalRowStyles = [
    {
        when: row => row.toggleSelected,
        style: {
            backgroundColor: "#EEEEEE",
            userSelect: "none",
            color: "#000300",
            border: "none",
        }
    }
];

import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux';
import { Button } from 'reactstrap';
import CustomLoading from '../Loading/CustomLoading';

const BuildingExcelTable = ({ columns, data, title }) => {
    const loader = useSelector((state) => state.ModalReducer?.loader)


    const [tableData, setTableData] = useState(data)

    useEffect(() => {
        setTableData(data);
    }, [data])
    function convertArrayOfObjectsToCSV(array) {
        let result;

        const columnDelimiter = ',';
        const lineDelimiter = '\n';
        const keys = Object.keys(data[0]);

        result = '';
        result += keys.join(columnDelimiter);
        result += lineDelimiter;

        array.forEach(item => {
            let ctr = 0;
            keys.forEach(key => {
                if (ctr > 0) result += columnDelimiter;

                result += item[key];

                ctr++;
            });
            result += lineDelimiter;
        });

        return result
    }

    function downloadCSV(array) {
        const link = document.createElement('a');
        let csv = convertArrayOfObjectsToCSV(array);
        if (csv == null) return;

        const filename = 'export.csv';

        if (!csv.match(/^data:text\/csv/i)) {
            csv = `data:text/csv;charset=utf-8,${csv}`;
        }

        link.setAttribute('href', encodeURI(csv));
        link.setAttribute('download', filename);
        link.click();
    }
    const Export = ({ onExport }) => <Button onClick={e => onExport(e.target.value)} className="fs-3 py-3 px-5  bg-base-color text-base-white border-0 btn btn-secondary shadow-none">Export CSV</Button>;
    const actionsMemo = React.useMemo(() => <Export onExport={() => downloadCSV(data)} />, []);
    return (
        <DataTable
            title={title ? title : "Building Investors"}
            customStyles={customStyles}
            columns={columns}
            data={tableData}
            highlightOnHover
            progressPending={loader}
            progressComponent={<CustomLoading />}
            pagination
            paginationPerPage={10}
            paginationRowsPerPageOptions={[5, 10, 15, 25, 50]}
            paginationComponentOptions={{
                rowsPerPageText: 'Records per page:',
                rangeSeparatorText: 'out of',
            }}
            actions={actionsMemo}
        />
    )
}

export default BuildingExcelTable